export default __webpack_public_path__ + "static/media/Super7_teenpatti.56b529b7.png";